<script>
import barba from '@barba/core';

export default {
    name: 'Bleed',
    mounted() {
        this.timeout = setTimeout(() => {
            barba.go('/projekte');
        }, 10000)
    },
    beforeDestroy() {
        clearTimeout(this.timeout);
    }
}
</script>
